import React from 'react';

import { connect, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { useRouteMatch } from 'react-router';
import { CallHistoryMethodAction, push } from 'connected-react-router';

import AppState from '@webapp/store/state';

import TakedownSubmit from './takedown-submit';
import TakedownSuccess from './takedown-success';
import { ReleaseStore } from '@common/types/release/release-store';

interface TakedownReleaseProps {
  push: (path: string) => CallHistoryMethodAction;
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  push: (path: string) => dispatch(push(path)),
});

export const TakedownRelease = ({ push }: TakedownReleaseProps) => {
  const [activeStore, setActiveStore] = React.useState<ReleaseStore[]>([]);
  const [submitted, setSubmitted] = React.useState<boolean>(false);

  const match = useRouteMatch<{ releaseId: string; artistId: string }>();
  const releaseId = match.params.releaseId;
  const artistId = match.params.artistId;
  const release = useSelector((state: AppState) =>
    state.catalog.releases.items.find((r) => r.id === releaseId)
  );

  // TODO: DEVTEAM-603 - isNFT needs to be integrated to know if the takedown is for an NFT item.
  const isNFT = false;

  if (submitted && release) {
    return (
      <TakedownSuccess
        activeStore={activeStore}
        isNFT={isNFT}
        push={push}
        releaseTitle={release?.title || ''}
      />
    );
  }

  return (
    <TakedownSubmit
      setSubmitted={setSubmitted}
      artistId={artistId}
      releaseId={releaseId}
      isNFT={isNFT}
      activeStore={activeStore}
      setActiveStore={setActiveStore}
      release={release}
      push={push}
    />
  );
};

export default connect(null, mapDispatchToProps)(TakedownRelease);
